module.exports = __webpack_public_path__ + "static/img/bg5.da02d817.png";